<template>
  <router-view/>
</template>

<script>

  export default {
    name: 'app'

  }
</script>

<style>
  #app {
    font-family: 'Roboto',sans-serif;
    font-size: 14px;
  }
</style>
